import { render, staticRenderFns } from "./item.vue?vue&type=template&id=851fccc2&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('851fccc2')) {
      api.createRecord('851fccc2', component.options)
    } else {
      api.reload('851fccc2', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=851fccc2&", function () {
      api.rerender('851fccc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skeleton-item/item.vue"
export default component.exports